export default __webpack_public_path__ + "static/media/dinoegg.e3bdf939.png";